import { render } from "./YachtDetails.vue?vue&type=template&id=375b44b6&scoped=true"
import script from "./YachtDetails.vue?vue&type=script&lang=ts"
export * from "./YachtDetails.vue?vue&type=script&lang=ts"

import "./YachtDetails.vue?vue&type=style&index=0&id=375b44b6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-375b44b6"

export default script